import { useSyncExternalStore } from "react";

/** components/assets/js/pwa.js, loaded by main.tsx. */
interface HumePwa {
  install: () => Promise<string>;
  canInstall: () => boolean;
}

declare global {
  interface Window {
    humePwa?: HumePwa;
  }
}

const EVENTS = ["pwa:installable", "pwa:installed"] as const;

function subscribe(onChange: () => void): () => void {
  EVENTS.forEach((name) => window.addEventListener(name, onChange));
  return () => EVENTS.forEach((name) => window.removeEventListener(name, onChange));
}

/** Whether this browser can install the app now, and the function that starts it (null when it can't). */
export function useInstallApp(): (() => void) | null {
  const can = useSyncExternalStore(subscribe, () => window.humePwa?.canInstall() ?? false);
  return can ? () => void window.humePwa?.install() : null;
}
